import { render, staticRenderFns } from "./AdminQuotesPage.vue?vue&type=template&id=12b4b5a6&scoped=true&"
import script from "./AdminQuotesPage.vue?vue&type=script&lang=js&"
export * from "./AdminQuotesPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminQuotesPage.vue?vue&type=style&index=0&id=12b4b5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4b5a6",
  null
  
)

export default component.exports